<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  maintenanceEdit,
  maintenanceDetail,
} from 'api/cost';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/cost/car/apply/maintenanceApply',
      formComponents: ['baseForm'],
    };
  },
  computed: {
    detailParams () {
      return {
        applyId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: maintenanceDetail,
    editApi: maintenanceEdit,
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
